import Shreepati from "../Img/Shreepati-Group-Reaching.jpg";
import Runwal from "../Img/Runwal-Logo.jpg";
import WebsiteForm from "./WebsiteForm";
import RunwalShow from "../Img/Runwal-Expo-singapore.png";
import { Helmet } from "react-helmet";
export default function Singapore() {
  return (
    <>
      <Helmet>
        <title>Mumbai Property Expo 2024 in Singapore</title>
        <meta property="og:locale" content="en_US" />
        <meta
          property="og:title"
          content="Mumbai Property Expo 2024 in Singapore"
        />
        <meta
          property="og:description"
          content="You're Invited to Visit Mumbai's Finest Luxury Property Expo"
        />
        <meta
          property="og:url"
          content="https://propexpo.infairs.co.in/singapore"
        />
        <meta
          property="og:image"
          content="https://propexpo.infairs.co.in/static/media/banner.988f8e827a1ed68a0267.png"
        />

        <link rel="canonical" href="https://propexpo.infairs.co.in/singapore" />
        <script>
          {`
    !function (f, b, e, v, n, t, s) {
      if (f.fbq) return; n = f.fbq = function () {
        n.callMethod ?
        n.callMethod.apply(n, arguments) : n.queue.push(arguments)
      };
      if (!f._fbq) f._fbq = n; n.push = n; n.loaded = !0; n.version = '2.0';
      n.queue = []; t = b.createElement(e); t.async = !0;
      t.src = v; s = b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t, s)
    }(window, document, 'script',
      'https://connect.facebook.net/en_US/fbevents.js');
    fbq('init', '814743875346609');
    fbq('track', 'PageView');`}
        </script>
        <noscript>
          {`
          <img
            height="1"
            width="1"
            style="display:none"
            src="https://www.facebook.com/tr?id=814743875346609&ev=PageView&noscript=1"
          />`}
        </noscript>
        <script
          async
          src="https://www.googletagmanager.com/gtag/js?id=G-CHSR254D36"></script>
        <script>
          {`window.dataLayer = window.dataLayer || [];
  function gtag(){dataLayer.push(arguments);}
  gtag('js', new Date());

  gtag('config', 'G-CHSR254D36');`}
        </script>
      </Helmet>

      <section className="lead-genration-page singapore-page">
        <div className="container-fluid">
          <div className="row mt-lg-5">
            <img src={RunwalShow} alt="Logo" className="img-fluid logo" />
            {/* <img src={Shreepati} alt="Logo" className="img-fluid logo-2" /> */}
            <div className="col-12 text-center color-theme mb-4 mb-lg-5">
              <h1 className="mb-0 ms-lg-5">
                You're Invited to Visit Mumbai's Finest Luxury Property Expo
              </h1>
            </div>
            <div className="col-lg-8">
              <div className="content content-singapore">
                {/* <img src={RunwalShow} alt="Logo" className="img-fluid" /> */}
                <h2> HOLIDAY INN SINGAPORE ORCHARD CITY CENTRE</h2>
                <h5> 11 Cavenagh Rd, Singapore 229616.</h5>
                <h3 className="mb-0 mt-3">27, October 2024.</h3>
                <h3>Sun from 11:00 am to 07:00 pm</h3>
              </div>
            </div>
            <div className="col-md-8 col-lg-4">
              <WebsiteForm />
            </div>
            <div className="col-12">
              <p className="text-white mt-5">
                Artist's Impression | T&C Apply | All Projects are RERA
                Approved.
              </p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
